import React from 'react';
import { BrandSelect, Col, FormModal, Row } from 'components';
import { useAddBrandModal } from './useAddBrandModal';
import { Form } from 'antd';
import { ValidationErrors } from 'constants/validations';

export interface AddBrandModal {
  openModal: boolean;
  recordId: string | undefined;
  onCancelModal: () => void;
}

export const AddBrandModal = (props: AddBrandModal) => {
  const { openModal, onCancelModal, recordId } = props;
  const { onFinish, isLoading, form, onCancel } = useAddBrandModal({ onCancelModal, recordId });
  return (
    <FormModal
      form={form}
      isLoading={isLoading}
      title={'Add Brand'}
      okText={'Add'}
      width={360}
      open={openModal}
      onSubmit={onFinish}
      onCancel={onCancel}
      onClose={onCancel}
    >
      <Row>
        <Col span={24}>
          <Form.Item
            label={'Brand*'}
            name={'brandId'}
            rules={[{ required: true, message: ValidationErrors.required('Brand') }]}
          >
            <BrandSelect size={'large'} />
          </Form.Item>
        </Col>
      </Row>
    </FormModal>
  );
};
